var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperationDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2ZM4 12a7.987 7.987 0 0 1 12.898-6.312l-11.21 11.21A7.951 7.951 0 0 1 4 12Zm8 8a7.951 7.951 0 0 1-4.898-1.688l11.21-11.21A7.987 7.987 0 0 1 12 20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationDisabled);
export default __webpack_public_path__ + "static/media/operationDisabled.4206b0359d551fd6928a6f6de8501f17.svg";
export { ForwardRef as ReactComponent };